import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Box, Text } from '@chakra-ui/react'

const ChartTip = forwardRef(({ title, text }, ref) => {
  return (
    <Box
      bg="brand.lightBlueGradient"
      p={'32px 42px'}
      boxShadow={'0 8px 14px 0 rgba(0,0,0,0.1)'}
      maxWidth="400px"
      width="100%"
      borderRadius="8px"
      alignSelf="flex-end"
      ml="16px"
      pos="relative"
      _after={{
        content: '""',
        width: '0px',
        height: '0px',
        borderBottom: 'solid transparent',
        borderBottomWidth: '16px',
        borderTop: 'solid transparent',
        borderTopWidth: '16px',
        borderRight: 'solid',
        borderRightWidth: '16px',
        borderRightColor: 'brand.lightBlue',
        position: 'absolute',
        bottom: 'calc(50% - 16px)',
        left: 0,
        transform: 'translateX(-100%)',
      }}
      ref={ref}
      zIndex={1}
      display={{ base: 'none', xl: 'block' }}
    >
      <Text textStyle="h2">{title}</Text>
      <Box
        pt="16px"
        color="brand.textBlue"
      >
        <Text noOfLines={5}>{text}</Text>
      </Box>
    </Box>
  )
})

ChartTip.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
}

export default ChartTip
